import React from 'react';

// import loadingSmall from 'assets/image/loading-small.gif';
import * as S from './styles';

import Buy from './Alter';
interface IAlterPlan {
  closeDrawer: () => void;
  valueCurrentPlan:number
  dateCurrentPlan:string
  currentBalance:number
  currentTotalBalance:number
}
const AlterPlan = ({ closeDrawer,currentBalance,currentTotalBalance,dateCurrentPlan,valueCurrentPlan }: IAlterPlan) => {
  // const Loader = () => {
  //   return (
  //     <S.Loader>
  //       <img src={loadingSmall} />
  //     </S.Loader>
  //   );
  // };
  return (
    <S.StyledDrawer open size="default" onCompleteClose={closeDrawer} noHeader>
      <Buy closeDrawer={closeDrawer} 
        currentBalance={currentBalance}
        currentTotalBalance={currentTotalBalance}
        dateCurrentPlan={dateCurrentPlan} 
        valueCurrentPlan={valueCurrentPlan}
      />
      {/* <Loader /> */}
    </S.StyledDrawer>
  );
};
export default AlterPlan;
